










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class TransactionsDetails extends Vue {
  @Prop({ required: true }) data!: any;

  get rawData() {
    return JSON.stringify(this.data, null, 2);
  }
}
